import { supabase } from '../lib/supabase'

async function countRows(table, organizacionId, filters = []) {
  let query = supabase.from(table).select('*', { count: 'exact', head: true }).eq('organizacion_id', organizacionId)
  filters.forEach(([column, value]) => { query = query.eq(column, value) })
  const { count, error } = await query
  if (error) throw error
  return count ?? 0
}

export async function getDashboardData(organizacionId) {
  const metricsPromise = Promise.all([
    countRows('cp_socios', organizacionId, [['estado', 'activo']]),
    countRows('cp_socios', organizacionId, [['estado', 'inactivo']]),
    countRows('cp_alumnos', organizacionId),
    countRows('cp_cursos', organizacionId, [['activo', true]]),
    countRows('cp_beneficios', organizacionId, [['activo', true]]),
  ])
  const sociosPromise = supabase.from('cp_socios').select('*').eq('organizacion_id', organizacionId).order('created_at', { ascending: false }).limit(5)

  const [[sociosActivos, sociosInactivos, alumnos, cursosActivos, beneficiosActivos], sociosResult] = await Promise.all([metricsPromise, sociosPromise])
  if (sociosResult.error) throw sociosResult.error
  return {
    metrics: { sociosActivos, sociosInactivos, alumnos, cursosActivos, beneficiosActivos },
    recentSocios: sociosResult.data ?? [],
  }
}
